import { JourneyStage } from 'types';

export enum Accent {
  Blue = 'blue',
  Purple = 'purple',
}

interface StepInternalClassNames {
  primaryClassName: string;
  secondaryClassName: string;
}

type StepColor = (typeof StepColors)[keyof typeof StepColors];

const StepColors = {
  Blue: '#2E22FF',
  Purple: '#8C0DB6',
} as const;

const stepClassNames: Record<StepColor, StepInternalClassNames> = {
  [StepColors.Blue]: {
    primaryClassName: 'bg-accent-gradient-primary-primary',
    secondaryClassName: 'bg-accent-gradient-secondary-primary',
  },
  [StepColors.Purple]: {
    primaryClassName: 'bg-accent-gradient-primary-primary',
    secondaryClassName: 'bg-accent-gradient-secondary-primary',
  },
};

export const getStepData = (color: string): StepInternalClassNames => {
  return (
    stepClassNames[color as StepColor] || {
      primaryClassName: 'bg-accent-gradient-primary-primary',
      secondaryClassName: 'bg-accent-gradient-secondary-primary',
    }
  );
};

export const getAccentFromColor = (color?: string): Accent =>
  color === StepColors.Purple ? Accent.Purple : Accent.Blue;

export type FormStepStages =
  JourneyStage.PRE_TRAINING | JourneyStage.POST_TRAINING;

export const FormStepDuration: Record<FormStepStages, string> = {
  [JourneyStage.PRE_TRAINING]: '2 mins',
  [JourneyStage.POST_TRAINING]: '2 mins',
};
